import React, { useState } from "react";
import { Link } from "react-router-dom";
import adyenLogo from "../assets/DIGITAL-Adyen-green-RGB.png";
import { FaBars, FaTimes } from "react-icons/fa"; // Ensure correct import

export const Layout = ({
  children,
  title,
}: {
  children: React.ReactNode;
  title: string;
}) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  return (
    <div
      className="flex-column justify-content-center align-items-center"
      style={{ width: "100vw" }}
    >
      <div
        className="w-100 text-light d-flex flex-column justify-content-center align-items-center"
        style={{
          backgroundColor: "#00112c",
          paddingTop: "30px",
          paddingBottom: "30px",
        }}
      >
        <div style={{ maxWidth: "80%", textAlign: "center" }}>
          <img
            className="mb-4"
            src={adyenLogo}
            style={{ maxWidth: 150 }}
            alt="Adyen Logo"
          />
          <h2>{title}</h2>
          <h3 style={{ color: "#08bf51" }}></h3>
        </div>
        <FaBars
          onClick={toggleSidebar}
          style={{
            position: "absolute",
            top: 20,
            left: 20,
            cursor: "pointer",
            fontSize: "1.5rem",
          }}
        />
      </div>
      {sidebarOpen && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "250px",
            height: "100%",
            backgroundColor: "#00112c",
            color: "white",
            padding: "20px",
            zIndex: 1000,
            boxShadow: "2px 0 5px rgba(0, 0, 0, 0.3)", // 陰影
          }}
        >
          <FaTimes
            onClick={toggleSidebar}
            style={{
              position: "absolute",
              top: 20,
              left: 20,
              cursor: "pointer",
              fontSize: "1.5rem",
            }}
          />

          <ul style={{ listStyleType: "none", padding: 0, marginTop: "60px" }}>
            <li style={{ marginBottom: "15px" }}>
              <Link
                to="/"
                style={{
                  color: "white",
                  textDecoration: "none",
                  fontWeight: "bold",
                }}
              >
                Check In
              </Link>
            </li>
            <li style={{ marginBottom: "15px" }}>
              <Link
                to="/card-check-point"
                style={{
                  color: "white",
                  textDecoration: "none",
                  fontWeight: "bold",
                }}
              >
                CheckPoint
              </Link>
            </li>
            <li style={{ marginBottom: "15px" }}>
              <Link
                to="/card-check-product"
                style={{
                  color: "white",
                  textDecoration: "none",
                  fontWeight: "bold",
                }}
              >
                CheckPoint Purchase
              </Link>
            </li>
          </ul>
        </div>
      )}
      <div className="mt-2 register-div w-100 d-flex flex-column justify-content-center align-items-center">
        {children}
      </div>
    </div>
  );
};
